import client from '../../../../common/client';

export const CREATE_ONLINE_FOLLOW_UP = 'CREATE_ONLINE_FOLLOW_UP';

export const createSession = (userId, values) => ({
  promise: client.post(`sessions/tathata-online-follow-up`, values),
  type: CREATE_ONLINE_FOLLOW_UP,
});



// WEBPACK FOOTER //
// ./src/subscription/coaching/online-follow-up/redux/actions.js